// What the header Location picker does on each page.
//
//   combine: tick one, several or all locations; the page adds them up.
//            Only pages whose server endpoints take `salonIds`.
//   switch:  pick the ONE location this device works at (diary, tills,
//            clients, catalogue, team, settings... everything else).
//   hidden:  the page is about the whole business, not a location.
//
// One list, so a page can't quietly behave differently from the rest.
const COMBINE = [
  /^\/finance\/?$/,
  /^\/marketing-home\/?$/,
  /^\/marketing-calendar\/?$/,
  /^\/marketing-performance\/?$/,
  /^\/marketing-campaigns\/?$/,
];
const HIDDEN = [
  /^\/settings\/billing\/?$/,
  /^\/subscription-checkout\/?$/,
  /^\/add-location(\/|$)/,
];

export function locationModeFor(pathname) {
  const p = String(pathname || '/');
  if (HIDDEN.some((re) => re.test(p))) return 'hidden';
  if (COMBINE.some((re) => re.test(p))) return 'combine';
  return 'switch';
}

// The town, from the salon's address ("12 High St, Norwich NR1 3AB, UK" ->
// "Norwich"): what tells two "Hair LAB"s apart.
const POSTCODE = /\s*[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}\s*$/i;
export const townOf = (s) => {
  const parts = String((s && s.formattedAddress) || '').split(',').map((x) => x.trim())
    .filter((x) => x && !/^(uk|united kingdom|england|scotland|wales|northern ireland)$/i.test(x));
  for (let i = parts.length - 1; i >= 0; i -= 1) {
    const t = parts[i].replace(POSTCODE, '').trim();
    if (t && !/^\d/.test(t)) return t;
  }
  return '';
};
